import { useEffect, useTimedAnimation } from '@frontend/react';
import { Button, Icon, Text, XStack, YStack, useViewportSize } from '@frontend/web-react';
import Confetti from 'react-confetti';

type GiftTaskSuccessProps = {
  onAnother: () => void;
  onDone: () => void;
  recipientEmail: string;
};

export const GiftTaskSuccess = ({ onAnother, onDone, recipientEmail }: GiftTaskSuccessProps) => {
  const { isAnimationOn, turnOnAnimation } = useTimedAnimation({ duration: 5000 });
  const { height, width } = useViewportSize();

  useEffect(() => {
    turnOnAnimation();
  }, []);

  return (
    <>
      <YStack className="items-center gap-lg p-xl">
        <XStack className="items-center justify-center size-xxl rounded-full bg-lime-200">
          <Icon color="primary" name="IconGift" size="xl" />
        </XStack>

        <YStack className="items-center gap-sm">
          <Text textAlign="center" type="h2">
            Gift sent!{' '}
            <span aria-label="celebration" role="img">
              🎉
            </span>
          </Text>
          <Text color="secondary" textAlign="center" type="p-md">
            {"We've"} emailed <strong>{recipientEmail}</strong> their gift.
          </Text>
        </YStack>

        <span aria-live="polite" className="sr-only">
          {`Gift sent to ${recipientEmail}.`}
        </span>

        <YStack className="w-full gap-sm">
          <Button fullWidth onClick={onAnother} variant="primary">
            Send another gift
          </Button>
          <Button fullWidth onClick={onDone} variant="tertiary">
            Done
          </Button>
        </YStack>
      </YStack>

      {isAnimationOn ? (
        <div aria-hidden role="presentation">
          <Confetti height={height} style={{ position: 'fixed', top: 0, zIndex: 1000 }} width={width} />
        </div>
      ) : null}
    </>
  );
};
